module.exports = __webpack_public_path__ + "img/sShkThaiX2_350x350.489dff43.jpg";